export const socialLinks = {
	facebook: "https://www.facebook.com/share/1C1Hu8qyPr/",
	instagram: "https://www.instagram.com/zealightlab?igsh=am13c2htOXQxYjNz",
	linkedin: "https://www.linkedin.com/company/zealight-labs/",
	twitter: "https://x.com/ZealightLabs",
};
